import { FC } from 'react'
import { useLoaderData } from 'react-router-dom'
import { useBreakpoint } from '@yuno/sdk-web-core/dist/hooks'
import { Layout, Order, OrderMobile, PaymentRedirect, PaymentCheckout } from '../../components'
import { getButtonStyles, PaymentRouterContainer } from './payment-route.styled'
import { useTranslation } from 'react-i18next'
import { queryClient } from '../../state'
import { CheckoutInfo } from '../../types'
import { checkoutInfoQueryKey } from '../../hooks'
import { Global } from '@emotion/react'
import { dynamicStyle } from './payment-route.styled'
import { dynamicDisplayRedirect } from '../../utils'

export const PaymentRoute: FC = () => {
  const workflow = useLoaderData()
  const { isMobile } = useBreakpoint()
  const { t } = useTranslation()
  const checkoutInfo = queryClient.getQueryData<CheckoutInfo>([checkoutInfoQueryKey])
  const displayValue = dynamicDisplayRedirect(checkoutInfo?.checkout_return_url)

  if (workflow === 'CHECKOUT') {
    return (
      <Layout
        section={t('Order review')}
        rightContent={
          <>
            {isMobile && <OrderMobile />}
            <PaymentCheckout />
          </>
        }
      >
        <Global styles={[
          dynamicStyle(displayValue), 
          getButtonStyles(checkoutInfo!.payment_link.style)
        ]} />
        <PaymentRouterContainer>
          <Order />
        </PaymentRouterContainer>
      </Layout>
    )
  }

  return (
    <>
      <Global styles={[dynamicStyle(displayValue)]} />
      <PaymentRedirect />
    </>
  )
}
